import { useEffect, useMemo, useState } from "react";
import { Shield } from "lucide-react";
import { cn } from "@/lib/cn";

export function ClubMark({
  name,
  imageUrl,
  fallbackImageUrl,
  className,
  initials = 1,
  label = "Club icon",
}: {
  name: string;
  imageUrl?: string | null;
  fallbackImageUrl?: string | null;
  className?: string;
  initials?: number;
  label?: string;
}) {
  const sources = useMemo(
    () =>
      [imageUrl, fallbackImageUrl].filter(
        (value, index, values): value is string =>
          Boolean(value) && values.indexOf(value) === index,
      ),
    [fallbackImageUrl, imageUrl],
  );
  const [sourceIndex, setSourceIndex] = useState(0);

  useEffect(() => setSourceIndex(0), [sources]);

  const letters =
    name
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((word) => word[0])
      .join("")
      .slice(0, initials)
      .toUpperCase() || "C";
  const source = sources[sourceIndex];
  const showImage = Boolean(source);

  return (
    <span
      className={cn("club-asset-mark", className)}
      aria-label={showImage ? label : `Default ${label.toLowerCase()}`}
    >
      {showImage ? (
        <img
          src={source}
          alt=""
          onError={() => setSourceIndex((current) => current + 1)}
        />
      ) : (
        <>
          <Shield aria-hidden />
          <strong aria-hidden>{letters}</strong>
        </>
      )}
    </span>
  );
}
